import React, { useState, useEffect } from "react";
import { TimePicker, Button, Form, Space, message } from "antd";
import dayjs from "dayjs";

const TimeSlotField = ({ name, form, initialTimeSlot }) => {
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  useEffect(() => {
    if (initialTimeSlot) {
      const [startStr, endStr] = initialTimeSlot.split("-");
      setStart(dayjs(startStr.trim(), "hh:mm A"));
      setEnd(dayjs(endStr.trim(), "hh:mm A"));
    }
  }, [initialTimeSlot]);

  const handleSetSlot = () => {
    if (!start || !end) {
      return message.error("Please select both start and end times");
    }

    const timeSlotString = `${start.format("hh:mm A")} - ${end.format("hh:mm A")}`;

    form.setFieldValue(name, [timeSlotString]); // ✅ Directly set on nested key path

    message.success("Time slot set!");
  };

  return (
    <Form.Item label="Time Slot">
      <Space wrap>
        <TimePicker
          format="hh:mm A"
          use12Hours
          style={{ width: 120 }}
          value={start}
          onChange={setStart}
          placeholder="Start"
        />
        <TimePicker
          format="hh:mm A"
          use12Hours
          style={{ width: 120 }}
          value={end}
          onChange={setEnd}
          placeholder="End"
        />
        <Button type="primary" onClick={handleSetSlot}>
          Set
        </Button>
      </Space>
    </Form.Item>
  );
};

export default TimeSlotField;
